(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection-list2"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection-pagination"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-related"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function initSection(root) {
      if (root.dataset.relmfInit) return;
      root.dataset.relmfInit = '1';

      // RTL helper: in RTL, scrollLeft runs negative; normalize math + sign.
      function isRTL(el) { return getComputedStyle(el).direction === 'rtl'; }

      // ---- carousel nav ----
      var track = root.querySelector('[data-relmf-track]');
      var prev = root.querySelector('[data-relmf-prev]');
      var next = root.querySelector('[data-relmf-next]');
      if (track && prev && next) {
        var update = function () {
          var max = track.scrollWidth - track.clientWidth - 2;
          var pos = Math.abs(track.scrollLeft);
          prev.hidden = pos <= 2;
          next.hidden = pos >= max;
          if (track.scrollWidth <= track.clientWidth + 4) { prev.hidden = true; next.hidden = true; }
        };
        var step = function () {
          var item = track.querySelector('.relmf__item');
          return item ? item.offsetWidth + 16 : track.clientWidth * 0.8;
        };
        prev.addEventListener('click', function () {
          var sign = isRTL(track) ? -1 : 1;
          track.scrollBy({ left: -step() * 2 * sign, behavior: 'smooth' });
        });
        next.addEventListener('click', function () {
          var sign = isRTL(track) ? -1 : 1;
          track.scrollBy({ left: step() * 2 * sign, behavior: 'smooth' });
        });
        track.addEventListener('scroll', update, { passive: true });
        window.addEventListener('resize', update);
        update();
      }

      // ---- swatch image swap + swatch nav ----
      root.querySelectorAll('[data-relmf-swatches]').forEach(function (row) {
        var card = row.closest('.relmf__card');
        var mainImg = card ? card.querySelector('[data-relmf-main-img]') : null;
        row.querySelectorAll('.relmf__swatch').forEach(function (sw) {
          sw.addEventListener('mouseenter', function () {
            if (mainImg && sw.dataset.img) mainImg.src = sw.dataset.img;
          });
          sw.addEventListener('click', function () {
            if (mainImg && sw.dataset.img) mainImg.src = sw.dataset.img;
          });
        });
        var swTrack = row.querySelector('[data-relmf-sw-track]');
        var swPrev = row.querySelector('[data-relmf-sw-prev]');
        var swNext = row.querySelector('[data-relmf-sw-next]');
        if (swTrack && swPrev && swNext) {
          var swUpdate = function () {
            var overflow = swTrack.scrollWidth > swTrack.clientWidth + 2;
            var pos = Math.abs(swTrack.scrollLeft);
            swPrev.hidden = !overflow || pos <= 2;
            swNext.hidden = !overflow || pos >= swTrack.scrollWidth - swTrack.clientWidth - 2;
          };
          swPrev.addEventListener('click', function () {
            var sign = isRTL(swTrack) ? -1 : 1;
            swTrack.scrollBy({ left: -90 * sign, behavior: 'smooth' });
          });
          swNext.addEventListener('click', function () {
            var sign = isRTL(swTrack) ? -1 : 1;
            swTrack.scrollBy({ left: 90 * sign, behavior: 'smooth' });
          });
          swTrack.addEventListener('scroll', swUpdate, { passive: true });
          swUpdate();
        }
      });

      // ---- quick view ----
      var modal = document.querySelector('[data-relmf-modal]');
      var modalBody = modal ? modal.querySelector('[data-relmf-modal-body]') : null;
      if (modal) {
        var closeModal = function () { modal.hidden = true; document.body.style.overflow = ''; };
        modal.querySelectorAll('[data-relmf-close]').forEach(function (el) { el.addEventListener('click', closeModal); });
        document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && !modal.hidden) closeModal(); });

        root.querySelectorAll('[data-relmf-qv]').forEach(function (btn) {
          btn.addEventListener('click', function () {
            modal.hidden = false;
            document.body.style.overflow = 'hidden';
            modalBody.innerHTML = '<div class="relmf-qv-modal__loading">Loading…</div>';
            fetch(btn.dataset.url + '.js')
              .then(function (r) { return r.json(); })
              .then(function (p) { renderQuickView(p, modalBody); })
              .catch(function () { modalBody.innerHTML = '<div class="relmf-qv-modal__loading">Could not load product.</div>'; });
          });
        });
      }

      function money(cents) {
        try {
          if (window.Shopify && Shopify.formatMoney) return Shopify.formatMoney(cents);
        } catch (e) {}
        return (cents / 100).toFixed(2);
      }

      function renderQuickView(p, container) {
        var state = { options: p.options_with_values || p.options.map(function (o, i) {
          return { name: o, position: i + 1, values: [] };
        }), selected: {} };

        var html = '<div class="relmf-qv">';
        var img = (p.featured_image) ? p.featured_image : (p.images && p.images[0]);
        html += '<div class="relmf-qv__media"><img src="' + (img || '') + '" alt="' + (p.title || '') + '"></div>';
        html += '<div class="relmf-qv__details">';
        html += '<h3 class="relmf-qv__title">' + p.title + '</h3>';
        var priceHtml = money(p.price);
        if (p.compare_at_price && p.compare_at_price > p.price) {
          priceHtml = money(p.price) + '<s>' + money(p.compare_at_price) + '</s>';
        }
        html += '<div class="relmf-qv__price" data-qv-price>' + priceHtml + '</div>';

        var optionNames = p.options.map(function (o) { return (typeof o === 'string') ? o : o.name; });
        optionNames.forEach(function (name, idx) {
          var values = [];
          p.variants.forEach(function (v) {
            var val = v.options[idx];
            if (values.indexOf(val) === -1) values.push(val);
          });
          state.selected[idx] = values[0];
          html += '<div class="relmf-qv__opt" data-opt-index="' + idx + '">';
          html += '<span class="relmf-qv__opt-label">' + name + '</span><div class="relmf-qv__values">';
          values.forEach(function (val, vi) {
            html += '<button type="button" class="relmf-qv__value" data-val="' + val.replace(/"/g, '&quot;') + '" aria-pressed="' + (vi === 0) + '">' + val + '</button>';
          });
          html += '</div></div>';
        });

        html += '<button type="button" class="relmf-qv__atc" data-qv-atc>Add to cart</button>';
        html += '<a class="relmf-qv__view" href="' + p.url + '">View full details &rarr;</a>';
        html += '</div></div>';
        container.innerHTML = html;

        function currentVariant() {
          return p.variants.find(function (v) {
            return optionNames.every(function (n, i) { return v.options[i] === state.selected[i]; });
          });
        }
        function refresh() {
          var v = currentVariant();
          var priceEl = container.querySelector('[data-qv-price]');
          var atc = container.querySelector('[data-qv-atc]');
          if (v) {
            var ph = money(v.price);
            if (v.compare_at_price && v.compare_at_price > v.price) ph = money(v.price) + '<s>' + money(v.compare_at_price) + '</s>';
            priceEl.innerHTML = ph;
            atc.disabled = !v.available;
            atc.textContent = v.available ? 'Add to cart' : 'Sold out';
            if (v.featured_image) container.querySelector('.relmf-qv__media img').src = v.featured_image.src;
          }
        }

        container.querySelectorAll('.relmf-qv__opt').forEach(function (optEl) {
          var idx = parseInt(optEl.dataset.optIndex, 10);
          optEl.querySelectorAll('.relmf-qv__value').forEach(function (b) {
            b.addEventListener('click', function () {
              optEl.querySelectorAll('.relmf-qv__value').forEach(function (x) { x.setAttribute('aria-pressed', 'false'); });
              b.setAttribute('aria-pressed', 'true');
              state.selected[idx] = b.dataset.val;
              refresh();
            });
          });
        });

        container.querySelector('[data-qv-atc]').addEventListener('click', function () {
          var v = currentVariant();
          if (!v || !v.available) return;
          var btn = this;
          btn.disabled = true; btn.textContent = 'Adding…';
          fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ items: [{ id: v.id, quantity: 1 }] })
          }).then(function (r) { return r.json(); })
            .then(function () {
              btn.textContent = 'Added ✓';
              document.dispatchEvent(new CustomEvent('cart:refresh'));
              try { document.dispatchEvent(new CustomEvent('cart:build')); } catch (e) {}
              setTimeout(function () { btn.disabled = false; btn.textContent = 'Add to cart'; }, 1500);
            }).catch(function () { btn.disabled = false; btn.textContent = 'Add to cart'; });
        });

        refresh();
      }
    }

    document.querySelectorAll('.relmf').forEach(initSection);
    document.addEventListener('shopify:section:load', function (e) {
      e.target.querySelectorAll('.relmf').forEach(initSection);
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
